import { API_KEYS } from "constants/apiEndpoints";
import { REDUX_ACTIONS } from "constants/constants";
import { requestPostFetchApi } from "utils/apiMethods";
import {
  getURLDetails,
  getUserHashToken,
  getUserPhone,
  getVendingMachineUuid,
} from "utils/commonMethods";

export const requestVmStock = () => {
  return async (dispatch) => {
    requestPostFetchApi(API_KEYS.GET_VM_PRODUCTS, {
      uuid: getVendingMachineUuid(),
      query: getURLDetails(),
      // phone_no: getUserPhone(),
      // hash: getUserHashToken(),
    }).then(
      (response) => {
        dispatch(dispatchVmStock(response.vm_stock));
      },
      () => {
        dispatch({ type: REDUX_ACTIONS.DUMMY_ACTION });
      }
    );
  };
};

const dispatchVmStock = (data) => {
  return {
    type: REDUX_ACTIONS.FETCH_VM_STOCK,
    payload: data,
  };
};

export const resetVmStock = () => {
  return {
    type: REDUX_ACTIONS.RESET_VM_STOCK,
  };
};

export const pushFilteredItemsToStock = (nextFilters) => {
  return {
    type: REDUX_ACTIONS.PUSH_FILTERED_VM_ITEMS,
    payload: nextFilters,
  };
};
